import './../lib/custom-select';

const select = $('select');

select.customSelect({
  transition: 200
});
